import { ArrayUtil } from './array.utils';

export default class SearchStringUtil {
  static normalize(str: string): string {
    const normalized = str.toLowerCase().normalize('NFD');
    const withoutAccents = normalized.replace(/[\u0300-\u036f]/g, '');
    const trimmed = withoutAccents.trim();
    return trimmed;
  }

  static prepareForSearch(paramValues: string | string[]): string[] {
    const values = ArrayUtil.getAsArray(paramValues);
    return values.flatMap((v) => this.splitToWords(v));
  }

  private static splitToWords(str: string): string[] {
    const normalized = this.normalize(str);
    return normalized.split(' ').filter(Boolean);
  }
}
